import { useEffect, useState } from "react";
import { getStoreBranches } from "../../../MyApi/stores";
import { useQuery } from "react-query";
import LoadingSpinner from "../../UI/spinner";

const ProductAvailability = ({
  setAvailability,
  availability,
  storeId,
  mode,
}) => {
  console.log("availability", availability);
  const { data, isLoading, error } = useQuery(
    "getStoreBranches",
    () => getStoreBranches(storeId ,"",1 ,1),
    { enabled: !!storeId },
  );
  
  const branches = [
    { id: storeId, name: "الرئيسي", type: "store" },
    ...(data?.data?.branches || []).map((b) => ({ ...b, type: "branch" })),
  ];
  const handleChange = (index, branch, e) => {
    const { name, value, type, checked } = e.target;
    console.log("stock_quantity", value);
    setAvailability((prev) => {
      const updated = [...prev];

      updated[index] = {
        ...updated[index],
        [name]:
          type === "checkbox"
            ? checked
              ? 1
              : 0
            : type === "number"
              ? Number(value)
              : value,
      };

      return updated;
    });
  };

  useEffect(() => {
    if (
      branches.length &&
      (!availability || !availability.length) &&
      data &&
      mode !== "edit"
    ) {
      setAvailability(
        branches.map((branch) => ({
          ...(branch.type === "store"
            ? { store_id: storeId }
            : { store_id: branch.id }),
          stock_quantity: 0,
          is_in_stock: 1,
          available_start_date: "",
          available_end_date: "",
          mode: "",
          max_quantity: "",
          reset_frequency: "",
          reset_day: "",
        })),
      );
    }
  }, [branches, data, availability]);

   const mergedBranches =
    mode === "edit"
      ? branches.map((branch) => {
          const existing = availability?.find(
            (a) => Number(a.store_id) === Number(branch.id)
          );
          return {
            ...branch,
            availability: existing || {
              store_id: branch.id,
              stock_quantity: 0,
              is_in_stock: 1,
              available_start_date: "",
              available_end_date: "",
              mode: "",
              max_quantity: "",
              reset_frequency: "",
              reset_day: "",
            },
          };
        })
      : branches;

      console.log('mergedBranches', mergedBranches)
  return (
    <form>
      <h5 className="fw-bold mb-2">إدارة المخزون والتوفر </h5>

      {mergedBranches.map((branch, index) => {
        const branchAvailability = availability[index] || {};

        return (
          <div className="row border p-3 mb-3 rounded" key={branch.id}>
            <h6 className="fw-bold mb-3">{branch.name || branch.store_name}</h6>

            <div className="col-md-6 mb-3">
              <label className="form-label">الكمية الحالية :</label>
              <input
                type="number"
                name="stock_quantity"
                className="form-control"
                value={branchAvailability.stock_quantity}
                onChange={(e) => handleChange(index, branch, e)}
                min={0}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">حالة التوفر :</label>
              <label className="switch">
                <input
                  type="checkbox"
                  name="is_in_stock"
                  checked={
                    branchAvailability.is_in_stock === 1 ||
                    branchAvailability.is_in_stock === true
                  }
                  onChange={(e) => handleChange(index, branch, e)}
                />
                <span className="slider round"></span>
              </label>
            </div>

            <>
          {branchAvailability.is_in_stock ==0  &&     <div className="col-md-6 mb-3">
                <label className="form-label">تاريخ البدء المتاح:</label>
                <input
                  type="date"
                  name="available_start_date"
                  className="form-control"
                  value={branchAvailability.available_start_date}
                  onChange={(e) => handleChange(index, branch, e)}
                />
              </div>}

              <div className="col-md-6 mb-3">
                <label className="form-label">تاريخ الانتهاء المتاح:</label>
                <input
                  type="date"
                  name="available_end_date"
                  className="form-control"
                  value={branchAvailability.available_end_date}
                  onChange={(e) => handleChange(index, branch, e)}
                  min={branchAvailability.available_start_date}
                />
              </div>
            </>

            {isLoading ? <LoadingSpinner /> : null}
            {branchAvailability.is_in_stock === 1 ||
            branchAvailability.is_in_stock === true ? (
              <>
                <div className="col-md-6 mb-3">
                  <label htmlFor="" className="form-label">
                    نوع إعادة التعبئة
                  </label>
                  <select
                    name="mode"
                    id="mode"
                    onChange={(e) => handleChange(index, branch, e)}
                    className="form-select"
                    value={branchAvailability.mode}
                  >
                    <option value=""> اختار الوضع </option>
                    <option value="manual">يدوي</option>
                    <option value="auto_reset">إعادة الضبط التلقائي</option>
                    <option value="unlimited">غير محدود</option>
                  </select>
                </div>
                {/* Max Quantity */}
                {branchAvailability.mode === "unlimited" ? null : (
                  <div className="col-md-6 mb-3">
                    <label htmlFor="" className="form-label">
                      كمية إعادة التعبئة
                    </label>
                    <input
                      type="number"
                      name="max_quantity"
                      min={0}
                      onChange={(e) => handleChange(index, branch, e)}
                      className="form-control"
                      value={branchAvailability.max_quantity}
                    />
                  </div>
                )}
                {/* Reset Frequency */}
                <div className="col-md-6 mb-3">
                  <label htmlFor="" className="form-label">
                    تكرار إعادة التعبئة
                  </label>
                  <select
                    value={branchAvailability.reset_frequency}
                    onChange={(e) => handleChange(index, branch, e)}
                    name="reset_frequency"
                    id="Reset_Frequency"
                    className="form-select"
                  >
                    <option value=""> اختار التكرار</option>
                    <option value="daily">يومي</option>
                    <option value="weekly">أسبوعي</option>
                    <option value="monthly">شهري</option>
                  </select>
                </div>
                {/* Reset day */}
                {branchAvailability.mode === "auto_reset" && (
                  <div className="col-md-6 mb-3">
                    <label htmlFor="" className="form-label">
                      تحديد اليوم
                    </label>
                    <input
                      name="reset_day"
                      type="number"
                      className="form-control"
                      onChange={(e) => handleChange(index, branch, e)}
                      min={0}
                      max={31}
                      value={branchAvailability.reset_day}
                    />
                  </div>
                )}
              </>
            ) : null}
          </div>
        );
      })}
    </form>
  );
};

export default ProductAvailability;
